<template>
  <div class="components full-page-width">
    <p class="m-b-40">List of components</p>
    <InputText
      class="m-b-40"
      placeholder="Enter value"
      label="Input Field"
      v-model="inputSearch" />
    <InputSelect
      class="m-b-40"
      label="Select"
      v-model="selectModel"
      @change="showNotification"
      :options="selectOptions" />
    <CountrySelect
      class="m-b-40"
      label="Select Country"
      v-model="country"
      @change="showNotification" />
    <div class="m-b-40">
      <v-date-picker color="green" v-model="date">
        <template v-slot="{ inputValue, showPopover }">
          <InputText
            class="d-block"
            placeholder="Date"
            label="Date"
            :value="inputValue"
            @focus="showPopover" />
        </template>
      </v-date-picker>
    </div>
    <div class="m-b-40">
      <p>Toggle Switch</p>
      <Toggle
        id="one"
        v-tooltip="{content: `Switch ${canEdit ? 'off' : 'on'}`}"
        @change="canEdit = !canEdit"/>
      <Toggle
        id="two"
        v-tooltip="{content: `Switch ${canEdit ? 'off' : 'on'}`}"
        @change="anotherEdit = !anotherEdit"/>
      <Checkbox
        v-model="selected"
        @change="selected = !selected" />
    </div>
    <div class="m-b-40">
      <p>Country flags</p>
      <CountryFlag country='rs' size='big'/>
      <CountryFlag country='rs' size='normal'/>
      <CountryFlag country='rs' size='small'/>
    </div>
    <div class="m-b-40">
      <PhoneSelect v-model="phone" />
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import CountryFlag from 'vue-country-flag';
import PhoneSelect from "@/components/elements/inputs/phone.vue";
import Checkbox from '@/components/elements/inputs/checkbox.vue';
import InputText from '@/components/elements/inputs/text.vue';
import InputSelect from '@/components/elements/inputs/select.vue';
import CountrySelect from '@/components/elements/inputs/countrySelect.vue';
import Toggle from '@/components/elements/inputs/toggle.vue';
import UploadArea from '@/components/elements/inputs/uploadArea.vue';

export default {
  name: 'Components',
  components: {
    CountryFlag,
    InputText,
    InputSelect,
    Checkbox,
    Toggle,
    CountrySelect,
    UploadArea,
    PhoneSelect,
  },
  data() {
    return {
      inputSearch: '',
      selectOptions: [],
      selectModel: '4',
      country: '173',
      date: new Date(),
      canEdit: false,
      anotherEdit: true,
      selected: false,
      uploadedFile: null,
      phone: '381',
    };
  },
  created() {
    // DUMMY API
    const self = this;
    setTimeout(() => {
      self.selectOptions = [
        { text: 'Opcija broj 12', value: 12 },
        { text: 'Prazan string', value: '' },
        { text: this.$t('yes'), value: 1 },
        { text: this.$t('no'), value: 2 },
        { text: 'Opcija text', value: 'Neka vrednost' },
        { text: 'Boolean False', value: false },
        { text: 'Boolean True', value: true },
        { text: 'Opcija broj 4', value: 4 },
        { text: 'Opcija broj 5', value: 5 },
        { text: 'Opcija broj 123', value: 123 },
        { text: 'Opcija broj 11', value: 11 },
        { text: 'Opcija broj 54', value: 54 },
        { text: 'Opcija broj 321', value: 321 },
        { text: 'Opcija broj 546', value: 546 },
        { text: 'Opcija broj 77', value: 77 },
        { text: 'Opcija broj 98', value: 98 },
        { text: 'Opcija broj 67', value: 67 },
        { text: 'Opcija broj 222', value: 222 },
      ];
    }, 2000);
  },
  methods: {
    changeFile(file) {
      this.uploadedFile = file;
    },
    showNotification(val) {
      this.$store.commit('SHOW_ERROR', `Select promenjen: ${val}`)
    },
  },
};
</script>
